import YFormHeading from './Heading';

export { YFormHeading };
export default YFormHeading;
